import script from "./Resume.vue?vue&type=script&setup=true&lang=js"
export * from "./Resume.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__